import * as basicLightbox from "basiclightbox";

window.modal = () => {
    return {
        modal: null,
        _scrollPosition: 0,

        init() {
            this.modal = basicLightbox.create(this.$el.querySelector("template"), {
                className: "basicLightbox--closable",
                onShow: (instance) => {
                    this._scrollPosition = window.pageYOffset;
                    document.body.classList.add("basicLightbox--enabled");
                    document.body.style.top = `-${this._scrollPosition}px`;

                    instance
                        .element()
                        .querySelectorAll("[data-close]")
                        .forEach((el) => {
                            el.addEventListener("click", () => {
                                this.close();
                            });
                        });
                    document.addEventListener("keydown", (event) => {
                        if (event.key === "Escape") {
                            this.close();
                        }
                    });
                },
                onClose: () => {
                    document.body.classList.remove("basicLightbox--enabled");
                    document.body.style.top = null;
                    window.scrollTo({
                        top: this._scrollPosition,
                        behavior: "instant",
                    });
                },
            });
        },

        open() {
            this.modal.show();
        },

        close() {
            this.modal.close();
        },
    };
};
